import React from "react";

function Icon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={12} height={12} fill="none">
      <path
        fill="#6C767F"
        d="M9 5.98 3.971 1 3 1.962 7.077 6 3 10.038l.971.962L9 6.02 8.98 6 9 5.98Z"
      />
    </svg>
  );
}

export default Icon;
